import module from 'cliente/module.js'
import template from './template.html'

export class ClienteInformacionRepresentanteComponent {
  data
  editando = false

  actualizar (data) {
    this.editando = false

    if (data) {
      Object.assign(this.data, data)
    }
  }
}

module.component('clienteInformacionRepresentante', {
  controller: ClienteInformacionRepresentanteComponent,
  template,
  bindings: {
    data: '<',
  },
})



// WEBPACK FOOTER //
// ./src/cliente/components/informacion/representante/component.js